import { setReportItem, setViewState } from './reducer';
import { getReportItemModel, postReport } from './api';
import { VIEW_STATES } from './constants';
import { logger } from 'packages/logger';
import { API_ERRORS } from 'tradera/utils/api';
import { getBackToHereRedirectUrl } from 'tradera/utils/url';
import { getReturnUrl } from 'tradera/utils/login';

const onLoggedOut = () => {
    window.location = `/login${getReturnUrl(getBackToHereRedirectUrl())}`;
};

export const loadReportItemModel = (itemId) => async (dispatch, getState) => {
    const reportItem = getState().views.reportItem;
    const isLoaded = reportItem.itemId === itemId;
    if (isLoaded) {
        dispatch(
            setViewState(
                reportItem.hasEnded ? VIEW_STATES.ITEM_ENDED : VIEW_STATES.FORM
            )
        );
        return;
    }
    try {
        dispatch(setViewState(VIEW_STATES.LOADING));
        const { data } = await getReportItemModel(itemId);

        dispatch(handleReportItemModel(data));
    } catch (error) {
        if (error.message === API_ERRORS.LOGGED_OUT) {
            onLoggedOut();
        } else {
            logger(error);
        }
    }
};

export const handleReportItemModel = (reportItemModel) => (dispatch) => {
    dispatch(setReportItem(reportItemModel));
};

export const submitReport =
    (itemId, reason, message, categoryId) => async (dispatch) => {
        dispatch(setViewState(VIEW_STATES.SUBMITTING));
        try {
            await postReport(itemId, reason, message, categoryId);
            dispatch(setViewState(VIEW_STATES.SUBMIT_SUCCESS));
        } catch (error) {
            logger(error);
            dispatch(setViewState(VIEW_STATES.SUBMIT_FAILED));
        }
    };
